<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">
  <div style="justify-content: center;align-self: center;margin-top: 2%;">
    <span style="font-size: 30px;">{{'Form Search' | translate | async}}</span>
  </div>


    <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">
      <div class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: 400px;">



        <mat-form-field class="header-form-full-width">
         
          <input matInput [matDatepicker]="picker" [(ngModel)]="StartDate" (ngModelChange) = "StartDateChanged($event);">
          <mat-placeholder >{{'Date Start' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
         
          <input matInput [matDatepicker]="pickerED" [(ngModel)]="EndDate" (ngModelChange) = "EndDateChanged($event);">
          <mat-placeholder >{{'Date End' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="pickerED"></mat-datepicker-toggle>
          <mat-datepicker #pickerED></mat-datepicker>
        </mat-form-field>

       

        <mat-form-field class="header-form-full-width">
         
          
          <mat-placeholder >{{'State'  | translate | async}}</mat-placeholder>
          <mat-select (selectionChange)="SitesChanged($event)" [(ngModel)]="SelectdState"  ngDefaultControl>
            <mat-option *ngFor="let _type of Sites" [value]="_type.ID">
              {{_type.SideCode}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
         
          <mat-label>{{'Related User'  | translate | async}}</mat-label>
          <!-- <mat-select (selectionChange)="RelatedUserChanged($event)" [(ngModel)]="SelectdRelatedUser"  ngDefaultControl>
            <mat-option *ngFor="let _type of RelatedUserList" [value]="_type.UserAuto">
              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-label>{{_type.UserName}}</mat-label>
                <mat-label style="color: lightgray;" *ngIf="_type.suspended==true">Suspended User</mat-label>
              </div>
                
            </mat-option>
          </mat-select> -->

          <input type="text" placeholder="{{'Related User' | translate | async}}"  [(ngModel)]="RelatedUserVal" (input)="changeRelatedUserAutoComplete($event)"   matInput  [matAutocomplete]="auto_">
          <mat-autocomplete [(ngModel)]="relatedUserTitle" #model_auto="ngModel"  #auto_="matAutocomplete" 
          (optionSelected)="relateduserselect($event.option.value)">
             <mat-option [value]="_type.UserName" *ngFor="let _type of RelatedUserList" >
             
              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-label>{{_type.UserName}}</mat-label>
                <mat-label style="color: lightgray;" *ngIf="_type.suspended==true">Suspended User</mat-label>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>


        <mat-form-field class="header-form-full-width">

          <mat-label>{{'Category'| translate | async}}</mat-label>
          <mat-select (selectionChange)="CategoryChanged($event)" [(ngModel)]="SelectedCategory" ngDefaultControl>
            <mat-option *ngFor="let _type of CategoryList" [value]="_type.ID">
              {{_type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-label >{{'Form' | translate | async}}</mat-label>

          <mat-select (selectionChange)="FormChanged($event)" [(ngModel)]="SelectedForm"  ngDefaultControl>
            <mat-option *ngFor="let _type of FormList" [value]="_type.ID">
              {{_type.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field class="header-form-full-width">
         
          <mat-label>{{'Person Responsible' | translate | async}}</mat-label>
          <!-- <mat-select (selectionChange)="PersonResponsibleChanged($event)"  ngDefaultControl>
   
            
            <mat-option  *ngFor="let _type of ResponsibleUserList" [value]="_type.UserAuto">
              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-label>{{_type.UserName}}</mat-label>
                <mat-label style="color: lightgray;" *ngIf="_type.suspended==true">Suspended User</mat-label>
              </div>
           
              
            </mat-option>
          </mat-select> -->



          <input type="text" placeholder="{{'Person Responsible' | translate | async}}" [(ngModel)]="PersonResVal" (input)="changeResposiblePersonAutoComplete($event)"   matInput  [matAutocomplete]="auto">
          <mat-autocomplete [(ngModel)]="resposiblepersonTitle" #model_auto_="ngModel"  #auto="matAutocomplete" (optionSelected)="ResposiblePersonselect($event.option.value)">
             <mat-option [value]="_type.UserName" *ngFor="let _type of ResponsibleUserList" >
              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-label>{{_type.UserName}}</mat-label>
                <mat-label style="color: lightgray;" *ngIf="_type.suspended==true">{{'Suspended User' | translate | async}}</mat-label>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>


      

        <mat-form-field class="header-form-full-width">
         
          <input matInput [matDatepicker]="pickerDueStart" [(ngModel)]="DueDateStart" (ngModelChange) = "DueDateStartChanged($event);">
          <mat-placeholder >{{'Due Date Start' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="pickerDueStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerDueStart></mat-datepicker>
        </mat-form-field>

        
        <mat-form-field class="header-form-full-width">
         
          <input matInput [matDatepicker]="pickerDueEnd" [(ngModel)]="DueDateEnd" (ngModelChange) = "DueDateEndChanged($event);">
          <mat-placeholder >{{'Due Date End' | translate | async}}</mat-placeholder>
          <mat-datepicker-toggle matSuffix [for]="pickerDueEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerDueEnd></mat-datepicker>
        </mat-form-field>

        
        <mat-form-field class="header-form-full-width">  
          <mat-label>{{'Supplier'| translate | async}}</mat-label>
          <mat-select  name="customer"  [(ngModel)]="selectedCustomer"  ngDefaultControl multiple>      
            <mat-option  *ngFor="let customer of _dropDownLists.customerList" [value]="customer.Id">
              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <mat-label>{{customer.Title}}</mat-label>             
              </div>                   
            </mat-option>
          </mat-select>
        </mat-form-field>

 
     

        <mat-form-field class="header-form-full-width invisible"  >
          <mat-select name="customer" class="invisible" >
        </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width invisible"  >
          <mat-select name="customer" class="invisible" >
        </mat-select>
        </mat-form-field>




        <div style="display: flex;flex-direction: column;height:40px">

          <mat-checkbox [(ngModel)]="FollowUpRequired">{{'Follow Up Required' | translate | async}}</mat-checkbox>
          <mat-checkbox [(ngModel)]="FollowUpCompleted">{{'Follow Up Completed' | translate | async}}</mat-checkbox>
          <mat-checkbox  #checkbox (change)="ChangeSuspendedUsers(checkbox.checked)"  [(ngModel)]="SuspendedUsers">{{'Suspended Related Users' | translate | async}}</mat-checkbox>
        </div>

        <div style="display: flex;flex-direction: column;min-width: 60%;height:40px">

          <mat-checkbox [(ngModel)]="ArchivedForms">{{'Archived Forms' | translate | async}}</mat-checkbox>
         
          <mat-checkbox [(ngModel)]="ActiveForms">{{'Active Forms' | translate | async}}</mat-checkbox>
        
        </div>
        <!-- <div style="min-width: 30%;width: 30%;"></div> -->



        <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
          <a class="button button--primary" (click)="onResetClick()"><span class="button__text">{{'Reset' | translate | async}}</span></a>
          <button style="margin-left: 20px;" class="button button--primary" (click)="onSearch()" cdkFocusInitial><span
              class="button__text">{{'Search' | translate | async}}</span></button>
        </div>

      </div>

    </mat-card>


    <div style="width: 100%;">
    <button mat-raised-button color="warn"  style="float: right;margin-right: 2%;" (click)="DownloadCSVFile()"><span class="material-icons button__icon">save_alt</span></button>

      <table *ngIf="isLoading != true" class="table table--full-width table--striped" style="margin-top: 9px;">
        <thead>
          <tr>
            <th style="display: flex;flex-direction: row;justify-content: space-between;">
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{"Date" | translate | async}}</span>

              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Category' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Form' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Related User' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Incident Type'  | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Date Due' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Person Responsible' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Form Type' | translate | async}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;    flex-direction: column;  margin-right: 10px;">
                <span
                  style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Add to Archive' | translate | async}}</span>
              
                  <mat-checkbox id="cbOPComponent_isActive" color="primary"
                  [(ngModel)]="cbAllFormsSelect"
                  (click)="toggleAllForms(!cbAllFormsSelect)"
                  style="margin-left: 32px!important; margin-right: 16px!important;align-self: center">
              </mat-checkbox>
              
                </div>

            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sr of SearchResultFormList">
            <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">

              <div style="display: flex;flex: 1;justify-content: center;">
                <span  (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.CompletedDate | date:'dd MMM yyyy'}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.FormCatName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.FormName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.userName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.IncidentTypeName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.FollowUpDate}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span (click)="onClickOpenForm(sr)"
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.FollowUpUserName}}</span>
              </div>
              <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                  class="material-icons-outlined">
                  <i *ngIf="sr.IsDigitalForm == true" class="material-icons">dynamic_form</i>
                  <i (click)="onClickDownloadForm(sr)" *ngIf="sr.IsDigitalForm != true"
                    class="material-icons">picture_as_pdf</i>
                </span>
              </div>
            
                <div style="display: flex;flex: 1;justify-content: center;">
                  <span
                    style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                    class="material-icons-outlined">

                    <mat-checkbox
                    id="chkComponent-{{sr.Id}}-{{sr.isArchived}}"
                    [checked]="sr.isArchived" [value]="sr.Id"
                    style="margin-left: 16px!important; margin-right: 16px!important;"
                    color="primary"
                    (change)="AddtoArchive(sr)">
                </mat-checkbox>

                  </span>
                </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
        <mat-spinner></mat-spinner>
      </div>

    </div>

  

</div>